import React, {Component} from "react";
import {connect} from 'react-redux';
import {loadCategories} from "../../actions/KnockoutQuestionBank/categories";
import {search, reset} from "../../actions/KnockoutQuestionBank/search";
import QuestionBankFilterForm from "./QuestionBankFilterForm.jsx";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import FilterList from '@material-ui/icons/FilterList';
import KnockoutQuestionBankItem from "./KnockoutQuestionBankItem";
import withStyles from "@material-ui/core/styles/withStyles";
import questionBankFilterFormStyle from "../../assets/jss/material-dashboard-pro-react/components/questionBankFilterFormStyle";
import {inlinePagination} from "../../utils/entityList";
import {getUrlQueryParams} from "../../utils/urls";

class KnockoutQuestionBankSearch extends Component {
    static defaultProps = {
        itemsPerPage: 15,
    };

    componentWillMount() {
        this.props.categories || this.props.loadQuestionBankCategories();
        this.props.retrieved || this.loadQuestions();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    paginate = (newUrl) => {
        const filters = getUrlQueryParams(newUrl);
        this.loadQuestions(filters);
    };

    loadQuestions = (filters = {}) => {
        filters['itemsPerPage'] = this.props.itemsPerPage;
        this.props.search(filters);
    };

    render() {
        const {categories, classes, retrieved, loading} = this.props;
        return (
            <>
                <ExpansionPanel className={classes.expansionPanel}>
                    <ExpansionPanelSummary expandIcon={<FilterList />} classes={{
                        root: classes.expansionPanelSummary,
                        content: classes.expansionPanelSummaryContent,
                        expanded: classes.expansionPanelSummaryExpanded,
                    }}>
                        <h2>Question Bank</h2>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        <QuestionBankFilterForm
                            onSubmit={this.loadQuestions}
                            formName="KnockoutQuestionBankFilterForm"
                            keywordFieldName="content"
                            categoriesFieldName="knockoutQuestionBankCategories"
                            categories={categories}
                        />
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {loading && (
                    <div className="alert alert-info">Loading...</div>
                )}
                {retrieved && retrieved['hydra:member'].map((knockoutQuestion, index) => {
                    return (<KnockoutQuestionBankItem key={index}
                                                      knockoutQuestion={knockoutQuestion}
                                                      onQuestionAdd={this.props.onQuestionAdd}
                    />);
                })}
                {!loading && retrieved && retrieved['hydra:member'].length === 0 && (
                    <Typography color="textSecondary">No results found. Please change your search criteria.</Typography>
                )}
                {inlinePagination(retrieved, this.paginate, {component: 'div', rowsPerPage: this.props.itemsPerPage})}
            </>
        )
    }
}

KnockoutQuestionBankSearch = withStyles(questionBankFilterFormStyle)(KnockoutQuestionBankSearch);

const mapStateToProps = state => {
    return {
        retrieved: state.knockoutquestionbank.search.retrieved,
        categories: state.knockoutquestionbank.categories.retrieved,
        error: state.knockoutquestionbank.search.error || state.knockoutquestionbank.categories.error,
        loading: state.knockoutquestionbank.search.loading,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    loadQuestionBankCategories: () => dispatch(loadCategories()),
    search: (filters) => dispatch(search(filters)),
    reset: () => dispatch(reset())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps)
(KnockoutQuestionBankSearch);
